import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-pin-complexity-check',
  templateUrl: './pin-complexity-check.component.html',
  styleUrls: ['./pin-complexity-check.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PinComplexityCheckComponent {



  @Input() public control: FormControl;


}
